import useGameStore from '@/store/gameStore';

function GameHeader() {
  const { gameState } = useGameStore();

  if (!gameState) return null;

  const getPhaseColor = (phase: string) => {
    const colors: Record<string, string> = {
      LOBBY: 'bg-gray-500',
      ROUND_SETUP: 'bg-blue-500',
      WRITING: 'bg-purple-500',
      REVIEW: 'bg-yellow-500',
      GUESSING: 'bg-green-500',
      SCORING: 'bg-orange-500',
      GAME_OVER: 'bg-red-500',
    };
    return colors[phase] || 'bg-gray-500';
  };

  const getPhaseText = (phase: string) => {
    const texts: Record<string, string> = {
      LOBBY: 'Waiting for Players',
      ROUND_SETUP: 'Setting up Round',
      WRITING: 'Write Your Clues!',
      REVIEW: 'Reviewing Clues',
      GUESSING: 'Time to Guess!',
      SCORING: 'Round Results',
      GAME_OVER: 'Game Over',
    };
    return texts[phase] || phase;
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold font-game text-primary-600">Just One</h1>
          <p className="text-sm text-gray-500 font-mono">
            Room Code: <span className="font-bold text-primary-600">{gameState.roomCode}</span>
          </p>
        </div>

        <div className="flex items-center gap-4">
          {/* Round Counter */}
          {gameState.round && (
            <div className="text-center">
              <p className="text-sm text-gray-500">Round</p>
              <p className="text-xl font-bold text-primary-600">
                {gameState.round.number}/{gameState.config.totalRounds}
              </p>
            </div>
          )}

          {/* Score */}
          <div className="text-center">
            <p className="text-sm text-gray-500">Score</p>
            <div className="flex gap-2 text-lg font-bold">
              <span className="text-success-600">✓ {gameState.deck.successCount}</span>
              <span className="text-danger-600">✗ {gameState.deck.failedCount}</span>
            </div>
          </div>

          {/* Phase Indicator */}
          <div
            className={`phase-indicator text-white ${getPhaseColor(gameState.phase)}`}
            data-testid="phase-indicator"
          >
            {getPhaseText(gameState.phase)}
          </div>
        </div>
      </div>

      {/* Timer Bar */}
      {gameState.round?.timerStartedAt && gameState.phase !== 'LOBBY' && (
        <div className="mt-4">
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
            <div
              className="timer-bar"
              style={{
                width: '100%',
                animation: `shrink ${gameState.round.timerDurationMs}ms linear`,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default GameHeader;
